import React, { FC } from "react";
import { observer } from 'mobx-react-lite';
import { SequenceReferenceTreeNodeLabel, TreeNode, TreeNodeLabel } from '../TreeNode';
import { InstructionNodeProps } from './InstructionNodeFactory';
import { TriggerInstruction } from '../../../../../machinelogic/types';

interface TriggerNodeProps extends InstructionNodeProps {
  instruction: TriggerInstruction;
}

const getInstructionLabelName = (instruction: TriggerInstruction): string => {
  switch(instruction.name) {
    case 'execute':
      return `Execute In Series`;
    case 'call':
      return `Execute in Parallel`;
    case 'pause':
      return `Pause`;
    case 'terminate':
      return `Terminate`;
  }
};

export const TriggerNode: FC<TriggerNodeProps> = observer(({instruction, titleClassName = '', isSelected, isInvalid, onClick}) => {

  const instructionLabel = <TreeNodeLabel
    icon='icon-trigger'
    name={getInstructionLabelName(instruction)}
    isSelected={isSelected}
    isInvalid={isInvalid}
    onClick={onClick}
  />;

  return (
    <TreeNode title={instructionLabel} titleClassName={titleClassName} >
      {(instruction.name === 'execute' || instruction.name === 'call') &&
      <TreeNode title={
        <SequenceReferenceTreeNodeLabel
          name={instruction.parameters.sequenceName}
          onClick={onClick}
          sequenceName={instruction.parameters.sequenceName}
        />
      }
      />
      }
    </TreeNode>
  );
});
